import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { type MediaTypeEntity } from '../entities/media.entity'

export class GetMediaTotalsQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly fromPrevious: string,
    private readonly toPrevious: string,
    private readonly mediaType: MediaTypeEntity,
    private readonly organization: string
  ) {
    super(ApiEndpoint.EngagementMediaTotals)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      from_previous: this.fromPrevious,
      to_previous: this.toPrevious,
      media_type: this.mediaType,
      organization: this.organization
    }
  }
}
